// frontend/src/services/notification.js

// Som de notificação suave (base64) para evitar problemas de download
// Um simples "ding" curto
const NOTIFICATION_SOUND = 'data:audio/mp3;base64,//uQRAAAAWMSLwUIYAAsYkXgoQwAEaYLWfkWgAI0wWs/ItAAAG1xVMQU1FMy45MqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqaqL5HUoxXHlGIdXhBlqNrE8BVIWdYCRDxp8CnqkpffBmZKDOSRCr8YKg9ktFSkVfmn0LOguR4JFjq2noOmKQdYQ0l0CpIsXCLMoEUpE+hZ1ijjm8GqO4k5KkOnDln36gmBm/mRzP6yyqapKrh+r796qTzH///1sxhXJc8l3///////7//uQRAAAAAAaQAAAAgAAA0gAAABAAABrRwAAAPRKwPtUcl8X65VNjdy03/6kWv/7n/9ua49kF818I1D//uUAAAAASUNDUMFNVQAIAAAAAIREMO//uQRAAAAAAaQAAAAgAAA0gAAABAAABrRwAAAP//uQRAAAAAAaQAAAAgAAA0gAAABAAABrRwAAAP';

class NotificationService {
    constructor() {
        this.audio = new Audio(NOTIFICATION_SOUND);
        this.hasPermission = false;

        this.checkPermission();
    }

    async checkPermission() {
        if (!("Notification" in window)) return;

        if (Notification.permission === "granted") {
            this.hasPermission = true;
        } else if (Notification.permission !== "denied") {
            const permission = await Notification.requestPermission();
            this.hasPermission = permission === "granted";
        }
    }

    play() {
        try {
            this.audio.currentTime = 0;
            const promise = this.audio.play();

            if (promise !== undefined) {
                promise.catch(error => {
                    console.log('Autoplay prevented:', error);
                });
            }
        } catch (e) {
            console.error('Error playing sound:', e);
        }
    }

    notify(title, body) {
        // Tocar som
        this.play();

        // Mostrar notificação nativa se permitido e janela em background
        if (this.hasPermission && document.hidden) {
            new Notification(title, { body, icon: '/favicon.ico' });
        }

        // Criar elemento de toast visual na tela
        this.showToast(title, body);
    }

    showToast(title, body) {
        const toast = document.createElement('div');
        toast.className = 'fixed top-4 right-4 bg-white border-l-4 border-blue-600 shadow-xl p-4 rounded z-50 animate-slide-in flex items-start max-w-sm';
        toast.innerHTML = `
            <div class="flex-1">
                <h3 class="font-bold text-gray-800 text-sm">${title}</h3>
                <p class="text-gray-600 text-sm mt-1">${body}</p>
            </div>
            <button onclick="this.parentElement.remove()" class="ml-4 text-gray-400 hover:text-gray-600">&times;</button>
        `;

        document.body.appendChild(toast);

        // Remover automaticamante após 3s
        setTimeout(() => {
            if (document.body.contains(toast)) {
                toast.classList.add('opacity-0', 'transition-opacity');
                setTimeout(() => toast.remove(), 300);
            }
        }, 5000);
    }
}

export const notificationService = new NotificationService();
